define('views/user/register/register',[
    "backbone",
    "text!views/user/register/register.html",
    "views/_base/baseview",
    "models/shared/lookups/states",
    "models/user/register/register",
    "models/user/register/eligibility",
    "models/shared/lookups/systext",
    "jqueryvalidate"
], function (Backbone, Template , BaseView, States, Register, Eligibility, SystemText, JqueryValidate) {
    "use strict";

    return BaseView.extend({
        isRender  : true,
        needsAuth : false,
        activityIndicator: false,
        template  : _.template(Template),
        tagName   : "section",
        id        : "newMemberRegister",
        className : "loggedOut",
        model     : Register,
        events    : {
            "focus .js-input-lastName": "lastNameTouched",
            "submit"                  : "register",
            "click .js-continue"      : "register",
            "keyUp"                   : "processKey",
            "change"                  : "validateApplication",
            "click #registerLogoIcon" : "goToLandingView",
            "click a"                 : "showMainHeader"
            
        },
        initialize: function (options) {
            options = options || {};
            this.emailAddress = "";
            var that = this;
            store.getStoreItem(enums.modelsEnum.SignUpEmailAddress, null, false, false, false, function (data) {
                that.emailAddress = data;
            });

            this.model = new Register();

            if (options.ReferralCode)
                this.ReferralCode = options.ReferralCode;
            else {
                store.getStoreItem(enums.modelsEnum.ReferralCode, null, false, false, false, function (data) {
                    that.ReferralCode = data;
                });
            }
            store.getStoreItem(enums.modelsEnum.campaign, null, false, false, false, function (data) {
                that.campaignCode = data;
                that.model.set({ CampaignCode: data })
            });

            this.lastNameFocused = false;

            if(pf.responsive){
                this.hideMainHeader();
            }

            this.eligibilityRequired = false;
            this.eligibilityStatus = null;
            this.eligibilityGuid = null;
            this.eligibilityRequestNotFound = 0;

            this.site_version = pf.content.version.number;

            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function (e) {
            var that = this;

            this.$el.html(this.template({ states: states, IA: sessionStorage.getItem("InvAccount") }));

            //Modified Palash to include dob start
            var thisYear = new Date().getFullYear();
            this.$('#dob').combodate({
                minYear: ( thisYear - 110 ),
                maxYear: ( thisYear - 18 ),
                smartDays: true,
                template: 'MMM D YYYY',
                format: 'MM/DD/YYYY',           // data-format= data-template=              
                firstItem: 'name'
            });

            //Modified Palash to include dob end

            var acceptTermsInput = "<label class='toggleInputLabel' for='Optional'><input type='checkbox' id='Optional' name='Optional' value='0' />I am at least 18 years of age and agree to the <a href='/terms-of-service' target='_blank'>Terms of Service</a> and <a href='/privacy-policy' target='_blank'>Privacy Policy</a></label>";
            this.$("#addcb").append(acceptTermsInput);

            if (this.emailAddress != "" && this.emailAddress != null) {
                this.$(".js-input-email").val(this.emailAddress);
                this.validateEach.validateEmail(null, that);
            }

            if (this.ReferralCode) {
                this.model.set({ ReferralCode: this.ReferralCode });
                var isValid = this.model.isValid('ReferralCode');
                this.validateEach.validateReferralCode(null, that);
            }

            this.addPfMobileAdvantages( $('.js-pfRegisterMobileAdvantages'), pf.getContent('register.app_incentives'));

            // This is needed to handle Anthem/Partner site differences in UI/Styling
            handlePartnerDiffs();

            if(this.site_version == enums.siteVersion.arizona){
                this.hideSensitiveFields();
            }

            this.$("#registrationForm").on("submit", function (e) { that.register(e) });

            return this;
        },

        hideSensitiveFields: function(){

            this.$('#dob').parent().hide();
            this.$('#ssn4').parent().hide();

        },

        goToLandingView: function(){
            pf.navigate('');
            this.showMainHeader();
        },
        addPfMobileAdvantages: function(el,path) {
            var html = '';
            $.each(path, function(){ html += '<li>'+this.copy+'</li>'; });
            el.html(html);
        },
        hideMainHeader: function(){
            $('#header-container').css('display','none');
        },
        showMainHeader: function(){
            $('#header-container').css('display','block');
        },
        register: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            this.monthFocused = true;
            this.dayFocused = true;
            this.yearFocused = true;

            var that = this;


            if (isEmpty(pf.session.get("_csrf"))) {
                pf.session.getAuth(function () {
                    that.registerUser(e);
                });
            } else {
                if (this.validateApplication(e)) {
                    this.registerUser(e);
                }
            }
        },
        sendEligibilityRequest: function(e,data){
            var that = this;

            this.eligibilityGuid = createReferenceNumber();

            data.appendEGUID = false;
            data.EGUID = this.eligibilityGuid;
            delete data.Email;
            delete data.Password;
            data.SSN4 = encrypt(this.$('#ssn4').val());
            this.userEligibility = new Eligibility(data);
            // this.userEligibility.set(data);

            this.userEligibility.save(null, {
                success: function (modelStatus, respStatus, options){
                    that.startStatusInterval(e,that,data);
                },
                error: function (modelStatus, respStatus, options){
                    if(respStatus.status == 200 || respStatus.status == 202){
                        that.startStatusInterval(e,that,data);
                    } else {
                        that.$(".js-continue").removeClass("btn-showSpinner");
                        that.$(".js-continue").attr('disabled', false);
                    }
                }
            });
        },
        startStatusInterval: function(e,that,data){
            that.eligibilityStatus = setInterval(function (){
                // Call the polling endpoint
                that.checkEligibility(e, that, data);
            }, 5000);
        },
        checkEligibility: function(e,that,data){

            that.userEligibilityGet = new Eligibility();
            that.userEligibilityGet.set(data);
            that.userEligibilityGet.set({
                EGUID: that.eligibilityGuid,
                appendEGUID: true
            });
            that.userEligibilityGet.fetch({
                success: function (modelStatus, respStatus, options) {

                    // 202: Processing, 200: Good
                    if(options.xhr.status == 200){
                        clearInterval(that.eligibilityStatus);

                        // Add the EGUID before the account is created
                        that.model.set({ EGUID: that.eligibilityGuid });

                        if(respStatus.hasOwnProperty('success') && respStatus.success == true){
                            that.createAccount(e,that);
                        } else {
                            // TBD: If the success flag isn't true then something may have gone wrong
                            that.createAccount(e,that);
                        }
                    } else if (options.xhr.status != 202){
                        clearInterval(that.eligibilityStatus);
                    }
                },
                error: function (modelStatus, respStatus, options) {
                    // TODO: Replace content with final content and add to content files
                    var title = 'You are not eligible',
                        body = JSON.parse(respStatus.responseText).ErrorMessage;

                    var cancelEligibilityCheck = function(titleTxt,bodyTxt){
                        // Cancel Interval
                        clearInterval(that.eligibilityStatus);
                        // Temporary message
                        pfdialog.error({
                            context: that,
                            // Title  : titleTxt,
                            Title  : '',
                            Body   : bodyTxt
                        });
                        that.$(".js-continue").removeClass("btn-showSpinner");
                        that.$(".js-continue").attr('disabled', false);
                    };

                    switch (respStatus.status){
                        case 404:
                            // Record wasn't found so try up to 3 times to allow network latency to catch up

                            if(that.eligibilityRequestNotFound >= 3){
                                cancelEligibilityCheck(title,body);
                            } else {
                                that.eligibilityRequestNotFound = that.eligibilityRequestNotFound+1;
                            }
                            break;
                        case 406:
                            // Not Eligible
                            cancelEligibilityCheck(title,body);
                            break;
                        case 500:
                            // Something unexplained happened
                            cancelEligibilityCheck(title,body);
                            break;
                        default:
                            // If some other error
                            cancelEligibilityCheck(title,body);
                            break;
                    };
                }
            });
        },
        registerUser: function (e) {
            var that = this;

            //Don't proceed if Agree not checked
            try {
                if (!$("#Optional")[0].checked) {
                    return false;
                }
            }
            catch (ex) { }

            // hp code
            try {
                if ($('#WebsiteInfo input').val() !== '') {                    
                    pfdialog.error({ context: that, Body: 'Registration failed', Title: "Error" });
                    return false;
                }
            } catch (ex) { }

            var data = this.$(".registrationForm").serializeObject();

            data.Email = data.Email.trim();
            //data.EmailConfirm = data.EmailConfirm.trim();

            data.Optional = (data.Optional !== undefined) ? true : false;
            data.Website = (data.Website !== "") ? true : false;            
            // data.IsAnthemMember = data.IsAnthemMember !== "0" ? true : false;
            // Temporary solution for removing "Are you an Anthem Member" on registration view
            data.IsAnthemMember = "0";
            data.IsMobileApp = (pf.session.inApp == true) ? true : false; // What is this?
            data.IsMobile = (pf.isMobile() == true) ? true : false;


            /* New change Palash Unsubscribe depends on cbUnbscribe
            //if (this.$("#emailList")[0].checked)
                data.Unsubscribe = 0;
            //else
              //  data.Unsubscribe = 1;
            */

            data.Unsubscribe = !this.$("#cbUnsubscribe")[0].checked;
            /* New change Palash Unsubscribe end */

            if (this.model == null)
                this.model = new Register();

            data.CampaignCode = this.campaignCode;
            this.model.set(data);

            this.$(".js-continue").addClass("btn-showSpinner");
            this.$(".js-continue").attr('disabled', true);


            if (this.eligibilityRequired){
                this.sendEligibilityRequest(e,data);
            } else {
                this.createAccount(e,that);
            }
        },
        createAccount: function (e,that){
            var psw = this.model.get("Password");
            this.model.set({ Email: encrypt(this.model.get("Email")), Password: encrypt(psw) });
            gAnalytics('SocialSignUp', 'Continue', 'Clicked');
            this.model.save(null, {
                success: function (model, resp, options){
                    // that.$(".spinner").addClass("hidden");
                    that.$(".js-continue").removeClass("btn-showSpinner");
                    that.disableControls(e);
                    store.removeStoreItem(enums.modelsEnum.ReferralCode);
                    store.removeStoreItem(enums.modelsEnum.SignUpEmailAddress);
                    pf.session.saveToken(resp);
                    //pf.session.manageCognito(psw);
                    pf.session.ZipCodeLive = resp.U.ZCL;
                    store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, { Data: 1 });
                    store.setStoreItem(enums.modelsEnum.IsRegistration, { Data: 1 });

                    //---------------------palash new reg change------------------------
                    pf.session.set('dob', $('#dob').val());
                    pf.session.set('ssn4', $('#ssn4').val());
                    //---------------------palash new reg change------------------------

                    that.showMainHeader();


                    /*   Palash new reg change navigate to financial registration instead
                    // TODO: Navigate to product selection
                    pf.navigate("wallet");
                     */

                    var product = enums.cardTypes.VirtualCard;
                    pf.require("views/user/register/financial/memberapplication", null, null, true, function (){
                        require(["views/user/register/financial/memberapplication"], function (FinancialRegView){
                            pf.show(new FinancialRegView({ elementName: "#mainRegion", product: product, isBcbsla: resp.OIWP }));
                        });
                    });

                    /*  Palash new reg change end */

                },
                error: function (model, resp, options){
                    // that.$(".spinner").addClass("hidden");
                    that.$(".js-continue").removeClass("btn-showSpinner");
                    switch (resp.status){
                        case 200:
                            that.disableControls();
                            if (!pf.session.inApp)
                                pf.show(new verificationView({ resp: resp }), "#mainRegion");
                            else
                            {
                                pf.session.saveToken(resp);
                                store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, { Data: 1 });
                                store.setStoreItem(enums.modelsEnum.IsRegistration, { Data: 1 });
                                that.showMainHeader();
                                pf.navigate("wallet");
                            }
                            break;
                        case 400:
                            that.disableControls();
                            var msg = jQuery.parseJSON(resp.responseText);
                            var closeWindow = msg.CloseWindow;
                            pfdialog.error({ context: that, Body: msg.Message, Title: "" });
                            if (closeWindow)
                            {
                                pf.viewLogin(true, null, null);
                            }
                            break;
                        case 401:
                            that.disableControls();
                            pfdialog.error({ context: that, Body: 'Registration failed' + ' for ' + e.target.Email.value, Title: "Failed" });
                            break;
                        default:
                            if(resp){
                                pf.session.saveToken(resp);
                                store.setStoreItem(enums.modelsEnum.EmailVerificationPassed, { Data: 1 });
                                store.setStoreItem(enums.modelsEnum.IsRegistration, { Data: 1 });
                            }
                            that.showMainHeader();
                            pf.navigate('wallet');
                    };
                }
            });
        },
        disableControls: function (e) {
            if (e && e.stopPropagation) { e.stopPropagation(); }
             this.$("#Activity").spin(false);
             this.$(".js-continue").removeAttr('disabled');
        },
       
        processKey: function(e) { 
            if(e.which === 13)
                this.submit();
        },
        validateApplication: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = this;

            var valid = true;
            var continueApplication = false;


            this.patterns = Backbone.Validation.patterns;
   
            var item = null;

            switch (e.target.id) {
                case "FirstName":
                    valid = this.validateEach.validateNames(e, that);
                    break;
                case "LastName":
                    valid = this.validateEach.validateNames(e, that);
                    break;
                case "Email":
                    valid = this.validateEach.validateEmail(e, that);
                    break;
                case "ZipCode":
                    valid = this.validateEach.validateZipCode(e, that);
                    break;
                case "ssn4":
                    valid = this.validateEach.validateSSN4( e, that);
                    break;
                case "Password":
                    valid = this.validateEach.validatePassword(e, that);
                    break;
                case "PasswordConfirm":
                    valid = this.validateEach.validatePasswordConfirm(e, that);
                    break;
                case "ReferralCode":
                    valid = this.validateEach.validateReferralCode(e, that);
                    break;
                case "Optional":
                    valid = this.validateEach.validateTermsAccepted(e, that);
                    break;
                // case "IsAnthemMember":
                //     valid = this.validateEach.validateAnthemMemberSelection(e, that);
                    break;
                case "reg":
                    that.lastNameTouched();
                    if (!this.validateEach.validateNames(e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateEmail(e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateZipCode(e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validatePassword(e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validatePasswordConfirm(e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateReferralCode(e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateTermsAccepted(e, that)) {
                        valid = false;
                    };

                    //modified palash new reg with dob start
                    if (!this.validateEach.validateDOB(e, that))
                    {
                        valid = false;
                    };
                    //modified palash new reg with dob end

                    //modified palash new reg with ssn4 start
                    if (!this.validateEach.validateSSN4(e, that))
                    {
                        valid = false;
                    }
                    //modified palash new reg with ssn4 end



                    // if (!this.validateEach.validateAnthemMemberSelection(e, that)) {
                    //     valid = false;
                    // };
            }
            return valid;
        },
        validateEach: {
            validateNames: function (e, that) {
                var item1 = that.$(".js-input-firstName");
                var item2 = that.$(".js-input-lastName");
                var itemMsg = that.$(".js-errorMsg-names");
                var isValid = true;

                // validate first name
                if (item1.val() == "" || !item1.val()) {
                    styleInputError(item1);
                    isValid = false;
                } else {
                    styleInputValid(item1);
                }
                // validate last name if it has been focused one time
                if (that.lastNameFocused) {
                    if (item2.val() == "" || !item2.val()) {
                        styleInputError(item2);
                        isValid = false;
                    }
                    else {
                        styleInputValid(item2);
                    }
                }
                // if either first or last are invalid
                if (isValid) {
                    removeErrorMsg(itemMsg);
                    return true;
                } else {                    
                    addErrorMsg(itemMsg, sysText['FV']['required']['name']);
                    return false;
                }
            },
            validateEmail: function ( e, that) {
                var item = that.$(".js-input-email");
                var itemMsg = that.$(".js-errorMsg-email");
                if (item.val() == "" || !item.val()) {
                    feedbackError(item, itemMsg, sysText['FV']['required']['email']);
                    return false;
                } else if (!isEmail(item.val())) {
                    feedbackError(item, itemMsg, sysText['FV']['invalid']['email']);
                    return false;
                } else {
                    var rVal = false;
                    $.ajax({
                        type: 'POST',
                        async:false,
                        url: pf.userURL + "/SignUp",
                        contentType: "application/json",
                        data: JSON.stringify({ Email:encrypt(item.val()) }),
                        success: function (response) {
                            var x = response;

                            var Success = response.Success;
                            var SignUpEmailExists = response.SignUpEmailExists;
                            var userExists = response.userExists;

                            if (userExists == true) {
                                feedbackError(item, itemMsg, sysText['FV']['invalid']['emailExists']);
                                rVal = false;
                            }
                            else if (SignUpEmailExists || Success) {
                                feedbackValid(item, itemMsg);
                                rVal = true;
                            }
                        },
                        error: function (response) {
                            rVal = false;
                        }
                    });

                    return rVal;
                }
            },
            validatePassword: function ( e, that) {
                var item = that.$(".js-input-password");
                var itemMsg = that.$(".js-errorMsg-password");
                var value = item.val();
                var pattern = new RegExp(/(?=^.{8,}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])/);

                itemMsg.removeClass("errorMessage--informative");
                if (value == null || value == "" || !pattern.test(value)) {
                    feedbackError(item, itemMsg, sysText['FV']['invalid']['password']);
                    return false;
                }  else {
                    feedbackValid(item, itemMsg);
                    return true;
                }
            },
            validatePasswordConfirm: function ( e, that) {
                var item = that.$(".js-input-confirmPassword");
                var itemMsg = that.$(".js-errorMsg-confirmPassword");
                var value = item.val();
                var pattern = new RegExp(/(?=^.{8,}$)(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])/);

                // if empty
                if (value == null || value == "") {
                    feedbackError(item, itemMsg, sysText['FV']['required']['passwordReenter']);
                    return false;
                // if doesn't pass regex, or doesn't match OG password
                } else if (!pattern.test(value) || item.val() != that.$(".js-input-password").val()) {
                    feedbackError(item, itemMsg, sysText['FV']['invalid']['passwordsDoNotMatch']);
                    return false;
                // Valid!
                } else {
                    feedbackValid(item, itemMsg);
                    return true;
                }
            },
            validateZipCode: function ( e, that) {
                var item = that.$(".js-input-zip");
                var itemMsg = that.$(".js-errorMsg-zip");
                if (item.val() == "" || !item.val()) {
                    feedbackError(item, itemMsg, sysText['FV']['required']['zipCode']);
                    return false;
                }
                else if (item.val().length != 5) {
                    feedbackError(item, itemMsg, sysText['FV']['invalid']['zipCode']);
                    return false;
                }
                else {
                    var zipValid = false;
                    $.ajax({
                        type: 'GET',
                        async: false,
                        url: pf.lookupsURL + "/ZipCodes/" + item.val(),
                        contentType: "application/json",
                        success: function () {
                            feedbackValid(item, itemMsg);
                            zipValid = true;
                        },
                        error: function () {
                            feedbackError(item, itemMsg, sysText['FV']['invalid']['zipCode']);
                            zipValid = false;
                        }
                    });

                    return zipValid;
                }
            },
            validateReferralCode: function ( e, that) {
                var item = that.$(".js-input-referralCode");
                var itemMsg = that.$(".js-errorMsg-referralCode");
                var value = item.val().trim();
                var codeValid = false;
                that.eligibilityRequired = false;

                if (item.val().length == 0) {
                    feedbackClear(item, itemMsg);
                    codeValid = true;
                    value = "0";
                }

                $.ajax({
                    type: 'GET',
                    async: false,
                    url: pf.lookupsURL + "/ReferralCode2/" + value,
                    contentType: "application/json",
                    success: function (resp)
                    {
                        codeValid = true;
                        if (resp.Flag2 === true){
                            that.eligibilityRequired = true;
                        }
                        feedbackValid(item, itemMsg);
                    },
                    error: function (err)
                    {
                        codeValid = false;
                        feedbackError(item, itemMsg, sysText['FV']['invalid']['promoCode']);
                    }
                });
                return codeValid;
            },
            validateTermsAccepted: function ( e, that) {
                var item = that.$("#Optional");
                var itemMsg = that.$(".js-errorMsg-terms");
                var value = item.val();
                if (item[0].checked == true) {
                    feedbackValid(item, itemMsg);
                    return true;
                }
                else {
                    feedbackError(item, itemMsg, sysText['FV']['required']['acceptTerms']);
                    return false;
                }
            },
            validateAnthemMemberSelection: function ( e, that) {
                var item = that.$("#IsAnthemMember");
                var itemMsg = that.$(".js-errorMsg-terms");
                var value = item.val();
                if (value == 0 || value == 1) {
                    feedbackValid(item, itemMsg);
                    return true;
                }
                else {
                    feedbackError(item, itemMsg, sysText['FV']['required']['isAnthemMember']);
                    return false;
                }
            },
            //modified palash new reg with dob start
            validateDOB: function (e, that) {
                var item = that.$("#dob");
                var itemMsg = that.$(".js-errorMsg-dob");

                var monthEl = that.$(".month");
                var dayEl = that.$(".day");
                var yearEl = that.$(".year");

                if(that.site_version == enums.siteVersion.arizona){
                    return true;
                }

                if (item.val() == "" || !item.val()) { // at least one select is empty
                    if (that.monthFocused) {
                        if ( monthEl.val() ) {
                            styleInputDefault(monthEl);
                        } else {
                            styleInputError(monthEl);
                        }
                    }

                    if (that.dayFocused) {
                        if (dayEl.val()) {
                            styleInputDefault(dayEl);
                        } else {
                            styleInputError(dayEl);
                        }
                    }
                    
                    if (that.yearFocused) {
                        if (yearEl.val()) {
                            styleInputDefault(yearEl);
                        } else {
                            styleInputError(yearEl);
                        }
                    }

                    if (that.monthFocused && that.dayFocused && that.yearFocused) {
                        addErrorMsg(itemMsg, sysText['FV']['required']['dob']);
                    }

                } else if (item.val()) { // there's a date in there
                    var dateOfBirth = item.val();
                    var arr_dateText = dateOfBirth.split("/");
                    var day = arr_dateText[1];
                    var month = arr_dateText[0];
                    var year = arr_dateText[2];

                    var mydate = new Date();
                    mydate.setFullYear(year, month - 1, day);

                    var ageDifMs = Date.now() - mydate.getTime();
                    var ageDate = new Date(ageDifMs);
                    var totalage = Math.abs(ageDate.getUTCFullYear() - 1970);

                    if (totalage < 18) {
                        feedbackError([$(".day"), $(".month"), $(".year")], itemMsg, sysText['FV']['invalid']['dob']);
                        return false;
                    } else {
                        feedbackClear([$(".day"), $(".month"), $(".year")], itemMsg, sysText['FV']['invalid']['dob']);
                        //if (!continueApplication)that.saveToSession(e);
                        var test = pf.session.get('dob');
                        return true;
                    }
                }
            },
            //modified palash new reg with dob end
            //modified palash new reg with ssn4 start
            validateSSN4: function (e, that) {
                var item = that.$("#ssn4");
                var itemMsg = that.$(".js-errorMsg-ssn4");
                var ssn = item.val();

                //ssn = ssn.replace(/-/gi, "");

                if(that.site_version == enums.siteVersion.arizona){
                    return true;
                }
                
                that.model.set({ 'SSN4': encrypt(ssn) });
                var isModelValid = that.model.isValid(true);
                var isValid = that.model.isValid('SSN4');
                //var errors = that.model.preValidate({ SSN: ssn});

                if (that.patterns.number.test(ssn) == false)
                {
                    feedbackError(item, itemMsg, sysText['FV']['required']['ssn4']);
                    return false;
                }
                else if (ssn.length != 4)
                {
                    feedbackError(item, itemMsg, sysText['FV']['invalid']['ssn4']);
                    return false;
                }
                else
                {
                    ssn = item.val();
                    //ssn = ssn.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
                    item.val(ssn);
                    feedbackValid(item, itemMsg, sysText['FV']['invalid']['ssn4']);
                    
                    return true;
                }
            },
            //modified palash new reg with ssn4 start
        },
        lastNameTouched: function() {
            this.lastNameFocused = true;
        },
        close: function () {
            store.removeStoreItem(enums.modelsEnum.SignUpEmailAddress);
            this.model = null;
        },
        //modified palash new reg start
        monthTouched: function (e)
        {
            this.monthFocused = true;
            this.validateEach.validateDOB(e, this);
        },
        dayTouched: function (e)
        {
            this.dayFocused = true;
            this.validateEach.validateDOB(e, this);
        },
        yearTouched: function (e)
        {
            this.yearFocused = true;
            this.validateEach.validateDOB(e, this);
        }
        //modified palash new reg start

    });
});

